export default __webpack_public_path__ + "static/media/6.77f91e95.png";